//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//交易量额度维护管理页面
const maintenanceManage = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/pages/purchaseSalesCenter/tradingQuota/applicationQuota/maintenanceManage.vue')),
    'maintenanceManage'
  );

//交易量额度新增
const addTransaction = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/tradingQuota/applicationQuota/add.vue')),
    'addTransaction'
  );

//交易量额度修改
const editTransaction = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/tradingQuota/applicationQuota/edit.vue')),
    'editTransaction'
  );

//交易量额度统计报表
const statisticalReports = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/pages/purchaseSalesCenter/tradingQuota/applicationQuota/statisticalReports.vue')
      ),
    'statisticalReports'
  );

//交易量额度分析报表
const analysisReport = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/pages/purchaseSalesCenter/tradingQuota/applicationQuota/analysisReport.vue')),
    'analysisReport'
  );

const tradingQuotaRouter = {
  path: '/applicationQuota',
  component: index,
  children: [
    {
      path: 'maintenanceManage',
      name: 'maintenanceManage',
      component: maintenanceManage,
      meta: {
        keepAlive: true,
        title: '交易量额度管理',
      },
    },
    {
      path: 'addTransaction',
      name: 'addTransaction',
      component: addTransaction,
      meta: {
        keepAlive: true,
        title: '交易量额度新增',
      },
    },
    {
      path: 'editTransaction',
      name: 'editTransaction',
      component: editTransaction,
      meta: {
        keepAlive: true,
        title: '交易量额度修改',
      },
    },
    {
      path: 'statisticalReports',
      name: 'statisticalReports',
      component: statisticalReports,
      meta: {
        keepAlive: true,
        title: '交易量额度统计报表',
      },
    },
    {
      path: 'analysisReport',
      name: 'analysisReport',
      component: analysisReport,
      meta: {
        keepAlive: true,
        title: '交易量额度分析报表',
      },
    },
  ],
};
export default tradingQuotaRouter;
